import { motion } from "motion/react";
import type { ReactNode } from "react";
import { Link } from "react-router";
import { Photo, type PhotoName } from "@/components/ui/photo";
import { ease } from "@/components/ui/reveal";

/** The head of a public page below the landing: a photo under a navy shade, a crumb, a labelled rule, a serif title, a lead. */
export function PublicPageHeader({ label, title, lead, photo, crumb }: { label: string; title: ReactNode; lead?: ReactNode; photo: PhotoName; crumb: string }) {
  return (
    <section className="public-page-header relative isolate overflow-hidden text-white">
      <Photo name={photo} fill sizes="100vw" decorative className="absolute inset-0" />
      <div aria-hidden className="hero-shade" />
      <div aria-hidden className="hero-grid" />
      <div className="relative mx-auto max-w-[1440px] px-4 pt-20 pb-14 sm:px-8 sm:pt-28 sm:pb-20">
        <motion.nav initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }} aria-label="パンくずリスト" className="flex items-center gap-2 text-[11px] font-bold tracking-[0.18em] text-white/60">
          <Link to="/" className="hover:text-white">HOME</Link>
          <span aria-hidden>/</span>
          <span>{crumb}</span>
        </motion.nav>
        <motion.p initial={{ opacity: 0, x: -10 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.9, delay: 0.05, ease }} className="section-label section-label--light mt-6">{label}</motion.p>
        <motion.h1 initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.1, delay: 0.15, ease }} className="hero-title mt-4 text-[clamp(1.9rem,3.6vw,3rem)]">{title}</motion.h1>
        {lead && <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.1, delay: 0.3, ease }} className="mt-5 max-w-2xl text-[15px] leading-[1.9] text-white/80">{lead}</motion.p>}
      </div>
    </section>
  );
}
